import React from 'react';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {
  LzTFormMethods,
  LzTFormTargets,
  LzTFunctionSimple,
  LzTResponsiveBreakpoint,
} from '../../typings';

export interface LzPForm {
  id?: string;
  name?: string;
  method?: LzTFormMethods;
  action?: string;
  target?: LzTFormTargets;
  flat?: boolean;
  size?: LzTResponsiveBreakpoint | false;
  className?: string;
  style?: React.CSSProperties;
  heading?: string;
  noAction?: boolean;
  submitLabel?: string;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  noCancel?: boolean;
  cancelLabel?: string;
  onCancel?: LzTFunctionSimple;
  showReset?: boolean;
  resetLabel?: string;
  onReset?: LzTFunctionSimple;
  children?: React.ReactNode;
}

const LzXForm = (props: LzPForm) => {
  const onSubmit: React.FormEventHandler<HTMLFormElement> = (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    if (props.onSubmit) {
      event.preventDefault();
      props.onSubmit(event);
      return;
    }
  };

  return (
    <Paper elevation={props.flat ? 0 : 2}>
      <Container maxWidth={props.size}>
        <form
          id={props.id}
          name={props.name}
          method={props.method}
          action={props.action}
          target={props.target}
          className={
            'lz-form ' + (props.className ? props.className + ' ' : ' ')
          }
          style={props.style}
          onSubmit={(event) => onSubmit(event)}
        >
          {props.heading && (
            <Typography
              variant='h6'
              display='block'
              style={{
                marginTop: 20,
                marginBottom: 20,
                textTransform: 'uppercase',
                color: 'gray',
              }}
            >
              {props.heading}
            </Typography>
          )}

          {props.children}

          {!props.noAction && (
            <React.Fragment>
              <div
                style={{
                  marginTop: '1em',
                  marginBottom: '1em',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  type='submit'
                  color='primary'
                  variant='contained'
                  style={{ marginLeft: 10 }}
                >
                  {props.submitLabel || 'Submit'}
                </Button>
                {!props.noCancel && (
                  <Button
                    type='button'
                    onClick={props.onCancel}
                    style={{ marginLeft: 10 }}
                  >
                    {props.cancelLabel || 'Cancel'}
                  </Button>
                )}
                {(props.showReset || props.onReset) && (
                  <Button
                    type={props.onReset ? 'button' : 'reset'}
                    style={{ marginLeft: 10 }}
                    onClick={props.onReset}
                  >
                    {props.resetLabel || 'Reset'}
                  </Button>
                )}
              </div>
            </React.Fragment>
          )}
        </form>
      </Container>
    </Paper>
  );
};

export default LzXForm;
